export default __webpack_public_path__ + "static/media/camila.a7d8d5b8.jpg";